import React, { Fragment } from "react";
import ReactCrop from "react-image-crop";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "react-image-crop/lib/ReactCrop.scss";
import "features/application/about/view.scss";

const AboutView = ({
  userData,
  references,
  backToPreviousStep,
  sendApiRequest,
  onSelectFile,
  crop,
  src,
  onImageLoaded,
  onCropComplete,
  onCropChange,
  croppedImageUrl,
  changeVisibility,
  previewVisibility,
  photoError,
}) => {
  return (
    <form
      className="form__content about__content"
      noValidate
      onSubmit={(event) => sendApiRequest(event, croppedImageUrl)}
    >
      <h1 className="application__headline form__elongation">About</h1>
      <p className="about__description">
        This is where Parlor gets exciting! Your information will help us match
        you with curated members and events. You are almost done!
      </p>
      <div className="about__photo form__elongation">
        <Field
          label="Profile photo"
          name="photo"
          type="photo"
          accept="image/jpeg,image/png"
          image={croppedImageUrl}
          shouldValidate={
            (userData &&
              !userData.avatar_file &&
              !croppedImageUrl.includes("base64")) ||
            Boolean(photoError)
          }
          rule="photo"
          error={photoError ? photoError : "This field is required."}
          reference={references.photo}
          handleChange={onSelectFile}
          photoError={photoError}
        />
      </div>
      {src && previewVisibility && (
        <div className="about__overlay">
          <ReactCrop
            src={src}
            crop={crop}
            ruleOfThirds
            onImageLoaded={onImageLoaded}
            onComplete={onCropChange}
            onChange={onCropChange}
            className="about__preview"
          />
          <button
            type="button"
            className="about__button"
            onClick={() => {
              onCropComplete().then(() => {
                changeVisibility();
              });
            }}
          >
            Crop
          </button>
        </div>
      )}
      <div className="form__elongation">
        <Field
          label="Educational background"
          name="education"
          type="text"
          maxLength={1000}
          value={userData && userData.education && userData.education}
          shouldValidate={true}
          rule="required"
          error="It doesn't look like a valid field."
        />
      </div>
      <Field
        label="Company"
        name="company"
        type="text"
        maxLength={42}
        value={userData && userData.company && userData.company}
        shouldValidate={true}
        rule="required"
        error="It doesn't look like a valid field."
      />
      <Field
        label="Position"
        name="position"
        type="text"
        maxLength={42}
        value={userData && userData.position && userData.position}
        shouldValidate={true}
        rule="required"
        error="It doesn't look like a valid field."
      />
      <div className="form__elongation">
        <div className="about__link">
          <Field
            label="Instagram link/handle or Facebook link"
            name="instagram_link"
            type="text"
            maxLength={500}
            value={
              userData && userData.instagram_link && userData.instagram_link
            }
            shouldValidate={
              userData &&
              references.instagramNotApplicable.current &&
              !references.instagramNotApplicable.current.checked
                ? true
                : false
            }
            rule="link"
            error="It doesn't look like a valid field."
            reference={references.instagram}
          />
          <div className="about__checkbox">
            <Field
              label="N/A"
              name="instagramNa"
              type="checkbox"
              isChecked={
                userData && userData.company && !userData.instagram_link
              }
              shouldValidate={false}
              rule="checkbox"
              reference={references.instagramNotApplicable}
            />
          </div>
        </div>
        <div className="about__link">
          <Field
            label="LinkedIn link or username"
            name="linkedin_link"
            type="text"
            maxLength={500}
            value={userData && userData.linkedin_link && userData.linkedin_link}
            shouldValidate={
              userData &&
              references.linkedinNotApplicable.current &&
              !references.linkedinNotApplicable.current.checked
                ? true
                : false
            }
            rule="link"
            error="It doesn't look like a valid field."
            reference={references.linkedin}
          />
          <div className="about__checkbox">
            <Field
              label="N/A"
              name="linkedinNa"
              type="checkbox"
              isChecked={
                userData && userData.company && !userData.linkedin_link
              }
              shouldValidate={false}
              rule="checkbox"
              reference={references.linkedinNotApplicable}
            />
          </div>
        </div>
        <Fragment>
          <Field
            label="Tell us about yourself"
            placeholder={
              references.instagramNotApplicable.current &&
              references.instagramNotApplicable.current.checked &&
              references.linkedinNotApplicable.current &&
              references.linkedinNotApplicable.current.checked
                ? ""
                : ""
            }
            name="bio"
            type="textarea"
            maxLength={1000}
            value={userData && userData.bio && userData.bio}
            shouldValidate={
              references.instagramNotApplicable.current &&
              references.instagramNotApplicable.current.checked &&
              references.linkedinNotApplicable.current &&
              references.linkedinNotApplicable.current.checked
                ? true
                : false
            }
            rule="required"
            error="This field is required because social media link not provided."
            reference={references.autobiography}
            styles={
              references.instagramNotApplicable.current &&
              references.instagramNotApplicable.current.checked &&
              references.linkedinNotApplicable.current &&
              references.linkedinNotApplicable.current.checked
                ? { display: "block" }
                : { display: "none" }
            }
          />
        </Fragment>
      </div>
      <div className="application__buttons form__elongation">
        <button
          className="application__button"
          type="button"
          onClick={backToPreviousStep}
        >
          Back
        </button>
        <button className="application__button" type="submit">
          Next
        </button>
      </div>
    </form>
  );
};

AboutView.propTypes = {
  userData: PropTypes.object,
  references: PropTypes.object,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,

  onSelectFile: PropTypes.func,
  crop: PropTypes.instanceOf(Object),
  src: PropTypes.string,
  onImageLoaded: PropTypes.func,
  onCropComplete: PropTypes.func,
  onCropChange: PropTypes.func,
  croppedImageUrl: PropTypes.string,
  changeVisibility: PropTypes.func,
  previewVisibility: PropTypes.bool,
  photoError: PropTypes.string,
  uploadImage: PropTypes.func,
};

export default AboutView;
